export default [
  { value: "HIGH CARD", key: 0 },
  { value: "PAIR", key: 1 },
  { value: "FLUSH", key: 2 },
  { value: "STRAIGHT", key: 3 },
  { value: "TRIPS", key: 4 },
  { value: "STRAIGHT FLUSH", key: 5 },
  { value: "MINI ROYAL", key: 6 },
];